import {useAuth} from "./hooks/useAuth";
import {Navigate} from "react-router-dom";

export const ProtectedRoute = ({children}: { children: JSX.Element }) => {
    const {adminCredential} = useAuth();
    if (!adminCredential || !adminCredential.token) {
        return <Navigate to="/login"/>;
    }
    return children;
};